// Pricing 定价页面翻译

export const pricing = {
    // Page title and subtitle
    chooseYourPlan: '選擇您的方案',
    selectPerfectPlan: '選擇最適合您創意需求的完美方案',
    
    // Billing cycle
    yearly: '年付',
    monthly: '月付',
    year: '年',
    month: '月',
    pack: '包',
    
    // Credit packs
    creditPacks: '積分包',
    
    // Plan status
    mostPopular: '最受歡迎',
    currentPlan: '當前方案',
    
    // Actions
    buyNow: '立即購買',
    subscribe: '訂閱',
    subscribeStarter: '訂閱入門版',
    subscribePro: '訂閱專業版',
    subscribePremium: '訂閱高級版',
    subscribeNow: '立即訂閱',
    processing: '處理中...',
    retry: '重試',
    cryptoPayment: '加密貨幣支付',
    
    // Loading states
    loading: '正在載入定價方案...',
    unableToLoadPlans: '無法載入定價方案',
    noPlansAvailable: '暫無可用方案',
    noPlansMessage: '目前沒有可用的{billingCycle}方案。',
    
    // Security and help
    securePayment: '由 Stripe 提供的安全支付',
    needHelp: '需要幫助？聯繫我們的支援團隊',
    
    // FAQ
    faqTitle: '常見問題',
    faqSubtitle: '找到關於我們定價和方案的常見問題答案',
    
    faq1Question: '我可以隨時更改方案嗎？',
    faq1Answer: '是的，您可以隨時升級或降級您的方案。更改將在下一個計費週期生效。',
    
    faq2Question: '您接受哪些付款方式？',
    faq2Answer: '我們通過安全的 Stripe 集成接受所有主要信用卡、PayPal 和其他付款方式。',
    
    faq3Question: '有免費試用嗎？',
    faq3Answer: '是的，所有新用戶註冊後都會收到免費積分來試用我們的服務。',
    
    faq4Question: '我可以隨時取消訂閱嗎？',
    faq4Answer: '是的，您可以隨時取消訂閱。您將繼續享有服務直到當前計費週期結束。',
    
    faq5Question: '未使用的積分會結轉嗎？',
    faq5Answer: '訂閱方案的積分會在每個計費週期結束時清零，不會結轉到下個月。但購買的積分包積分永久有效，不會過期。',
    
    faq6Question: '年度方案有折扣嗎？',
    faq6Answer: '是的，年度方案相比月度計費提供顯著節省。折扣會自動應用。'
  };
